<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th class="_numberColumn"[i18nKey]="'common.quantity'"></th>
            <th class="_numberColumn"[i18nKey]="'common.price'"></th>
            <th class="_numberColumn"[i18nKey]="'common.studies.turnover.with.taxes'"></th>
            <th class="_numberColumn"[i18nKey]="'common.studies.turnover.excluding.taxes'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.foodstuff'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr *ngFor="let dishSales of study.salesResult.firstCoursesALaCarteSales | keyvalue">
            <td>
                {{'menu.' + dishSales.key | translate}}
            </td>
            <td class="_number">
                {{dishSales.value | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.menuSalesPrices.firstCoursesSalesPrices[dishSales.key].salePriceIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.firstCoursesALaCarteTurnoversIncludingTaxes[dishSales.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.firstCoursesTurnoversExcludingTaxes[dishSales.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr *ngFor="let dishSalesPrices of study.menuSalesPrices.meatDishesSalesPrices | keyvalue">
            <td>
                {{'menu.' + dishSalesPrices.key | translate}}
            </td>
            <td class="_number">
                {{study.salesResult.mainCoursesALaCarteSales[dishSalesPrices.key] | number:'1.0'}}
            </td>
            <td class="_number">
                {{dishSalesPrices.value.salePriceIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.mainCoursesALaCarteTurnoversIncludingTaxes[dishSalesPrices.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.mainCoursesTurnoversExcludingTaxes[dishSalesPrices.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr *ngFor="let dishSalesPrices of study.menuSalesPrices.fishDishesSalesPrices | keyvalue">
            <td>
                {{'menu.' + dishSalesPrices.key | translate}}
            </td>
            <td class="_number">
                {{study.salesResult.mainCoursesALaCarteSales[dishSalesPrices.key] | number:'1.0'}}
            </td>
            <td class="_number">
                {{dishSalesPrices.value.salePriceIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.mainCoursesALaCarteTurnoversIncludingTaxes[dishSalesPrices.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.mainCoursesTurnoversExcludingTaxes[dishSalesPrices.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr *ngFor="let dishSalesPrices of study.menuSalesPrices.dessertsSalesPrices | keyvalue">
            <td>
                {{'menu.' + dishSalesPrices.key | translate}}
            </td>
            <td class="_number">
                {{study.salesResult.dessertsALaCarteSales[dishSalesPrices.key] | number:'1.0'}}
            </td>
            <td class="_number">
                {{dishSalesPrices.value.salePriceIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.dessertsALaCarteTurnoversIncludingTaxes[dishSalesPrices.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.dessertsTurnoversExcludingTaxes[dishSalesPrices.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.FIRST_COURSE_MAIN_COURSE'"></td>
            <td class="_number">{{study.salesResult.firstCourseMainCourseMenuSales | number:'1.0'}}</td>
            <td class="_number">
                {{study.menuSalesPrices.firstCourseMainCourseMenu.salePriceIncludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.firstCourseMainCourseMenuTurnoverIncludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.firstCourseMainCourseMenuTurnoverExcludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.MAIN_COURSE_DESSERT'"></td>
            <td class="_number">{{study.salesResult.mainCourseDessertMenuSales | number:'1.0'}}</td>
            <td class="_number">
                {{study.menuSalesPrices.mainCourseDessertMenu.salePriceIncludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.mainCourseDessertMenuTurnoverIncludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.mainCourseDessertMenuTurnoverExcludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.FULL_COURSE'"></td>
            <td class="_number">{{study.salesResult.fullCourseSales | number:'1.0'}}</td>
            <td class="_number">
                {{study.menuSalesPrices.fullCourse.salePriceIncludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.fullCourseTurnoverIncludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.fullCourseTurnoverExcludingTax | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.foodstuff.total'"></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.turnoverIncludingTax.totalDishesTurnoverIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_totalColumn _number">{{study.turnoverExcludingTax.totalDishesTurnoverExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.drinks'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr *ngFor="let dishSales of study.salesResult.winesSales | keyvalue">
            <td>
                {{'menu.' + dishSales.key | translate}}
            </td>
            <td class="_number">
                {{dishSales.value | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.menuSalesPrices.winesSalesPrices[dishSales.key].salePriceIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverIncludingTax.winesTurnoversIncludingTaxes[dishSales.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.turnoverExcludingTax.winesTurnoversExcludingTaxes[dishSales.key] | number:'1.2'}}
                <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.drinks.total'"></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.turnoverIncludingTax.totalWinesTurnoverIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_totalColumn _number">{{study.turnoverExcludingTax.totalWinesTurnoverExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.total'"></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.turnoverIncludingTax.totalTurnoverIncludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_totalColumn _number">{{study.turnoverExcludingTax.totalTurnoverExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        </tbody>
    </table>
</div>
